export type UpdateLensSymbolAction = { type: 'updateAlphaLensSymbol'; tabId: string; symbol: string };
export const updateAlphaLensSymbol = (tabId: string, symbol: string): UpdateLensSymbolAction => ({
    tabId,
    symbol,
    type: 'updateAlphaLensSymbol',
});

export type UserSelectedNewAlphaLensSymbolAction = {
    type: 'userSelectedNewAlphaLensSymbol';
    symbol: string;
    tabId: string;
};

export const userSelectedNewAlphaLensSymbol = (
    tabId: string,
    symbol: string,
): UserSelectedNewAlphaLensSymbolAction => ({
    symbol,
    tabId,
    type: 'userSelectedNewAlphaLensSymbol',
});

/**
 * Persisted chart collapse state
 */
export type SetAlphaLensChartCollapseAction = {
    type: 'setAlphaLensChartCollapse';
    tabId: string;
    /**
     * Current user choice to persist as the default value for the widget by tab-id
     * Default value is true.
     */
    collapsed: boolean;
    skipDirtyCheck?: boolean;
};

export const setAlphaLensChartCollapse = (
    payload: Omit<SetAlphaLensChartCollapseAction, 'type'>,
): SetAlphaLensChartCollapseAction => ({
    type: 'setAlphaLensChartCollapse',
    ...payload,
});

export type AlphaLensActions =
    | UpdateLensSymbolAction
    | UserSelectedNewAlphaLensSymbolAction
    | SetAlphaLensChartCollapseAction;
